/**
 * Per-page SEO service.
 *
 * One Firestore doc per static page key (home, about, containers, blogs,
 * contact, customised, privacy, terms, sitemap), each holding
 * { title, description, keywords[], slug }. Products, categories and posts
 * instead carry their own nested `seo` object on the entity.
 *
 * Managed from /admin/seo.
 */
import { mockPageSeo } from "@/data/mock-settings";
import { USE_MOCK_DATA } from "@/lib/firebase";
import { getByIdCached } from "@/lib/firestore-data";

const delay = (ms = 30) => new Promise((res) => setTimeout(res, ms));

export async function getPageSeo(pageKey) {
    if (USE_MOCK_DATA) {
        await delay();
        return mockPageSeo[pageKey] || null;
    }

    try {
        return await getByIdCached("pageSeo", pageKey);
    } catch (err) {
        // SEO tags are decoration, not content: a failed read must not take the
        // page down. Fall back to the bundled defaults.
        console.warn(`[seo] falling back to bundled SEO for "${pageKey}":`, err.message);
        return mockPageSeo[pageKey] || null;
    }
}
